module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAYAAAADU1RxAAAAQElEQVRIx2N8r637n2GAAeOoI0YdMSgd8dHb99iAO+I/EIw6YtQRo47A5ojCM28GPosyLL77f9QRo44YdQQWAAANpDnZuzW3HQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/lu.png
// module id = 874
// module chunks = 0